import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import envMode from '@utils/ajax/http'
import Store from '@utils/storage/storage'
import Cookies from '@/utils/cookie/cookie.js'
import DialogBox from '@/components/model_dialog/index'
import '@res/styles/index.scss'
import '@utils/flexible'
import './assets/css/reset.css'// 重置样式，字体
import '@/assets/css/element-ui.scss'
// 统一组件
import yqComponent from 'yq-component'
import 'yq-component/lib/jerryComponent.css'
// 混入
import mixin from './mixins/index'

import i18n from './i18n/index'
// 图片裁剪
import VueCropper from 'vue-cropper'
// import locale from 'element-ui/lib/locale/lang/en'
Vue.config.productionTip = false
Vue.use(Router)
Vue.use(yqComponent)
Vue.use(VueCropper)
Vue.use(DialogBox)

/* Vue.use(ElementUI, {
  locale
}) */
Vue.mixin(mixin)

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

if (process.env.NODE_ENV === 'ncic') {
  const lang = Cookies.get('lang')
  document.title = lang === 'zh' ? 'Radix 学校系统' : 'Radix School System'
} else {
  document.title = 'School365'
}

// if (process.env.NODE_ENV === 'uat') {
//   document.title = 'School365 System'
// }

Vue.prototype.$request = envMode.request
Vue.prototype.$Storage = Store

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js